// extracted by mini-css-extract-plugin
export var overlay = "PageOverlay-module--overlay--12xEG";
export var visible = "PageOverlay-module--visible--3SeTT";